// Import external
import { Component, Input } from '@angular/core';
import * as _ from 'lodash';

@Component({

    selector: 'syn-months-matrix',
    templateUrl: 'months-matrix.component.html',
    styleUrls: ['months-matrix.component.scss']
})
export class MonthsMatrixComponent {

    // Constants
    static LabelTypes = ['alias', 'name'];

    // Inputs
    @Input() public startMonth = 1;
    @Input() public matrix = [3, 4];
    @Input() public labelType = MonthsMatrixComponent.LabelTypes[0];
    @Input() public actualMonth: number;
    @Input() public highlightedMonths: number[];
    @Input() public checkedMonths: any;

    public monthsName = [
        'Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin',
        'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Decembre'
    ];
    public monthsAlias = ['Jan', 'Fév', 'Mar', 'Avr', 'Mai', 'Jun', 'Jul', 'Aoû', 'Sep', 'Oct', 'Nov', 'Dec'];

    public count() {
        return this.matrix[0] * this.matrix[1];
    }

    public getIndex(line, column) {
        return line * this.matrix[0] + column + this.startMonth - 1;
    }

    public filler(length) {
        return _.map(
            _.fill(Array(length), 1),
            (x, i) => i
        );
    }

    public isActive(line, column) {
        return this.getIndex(line, column) + 1 === this.actualMonth;
    }

    public isHighlighted(line, column) {
        return _.indexOf(this.highlightedMonths, this.getIndex(line, column) + 1) !== -1;
    }
}
